import { Divider, message, Select } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PageHeader, RequiredIndicator, SaveButton } from "../components";
import { appLinks, SaveButtonActions } from "../helpers/config";
import { Modal, Switch } from "@mantine/core";
// import { RichTextEditor } from "@mantine/rte";
import { callSchema } from './../helpers/schemas';
import { postNewCall } from "../helpers/api";
import { EditPatientForm } from '.';
import { useMutation } from 'react-query';
import _ from "lodash";
import { calcAge } from "../helpers/utilities";

const callState = {
  summary: '',
  isProxyCall: false,
  callerNumber: '',
  callerLocation: '',
  callType: '',
  patientId: null,
};

const InBoundCall = ( props ) => {
  const [ call, setCall ] = useState( callState );
  const [ patient, setPatient ] = useState( {} );
  const [ route, setRoute ] = useState( {
    url: -1,
    options: {
    }
  } );

  const [ editPatient, setEditPatient ] = useState( false );



  const navigate = useNavigate();
  const location = useLocation();



  const handleUpdateField = ( field, value ) => {
    setCall( {
      ...call,
      [ field ]: value
    } );
  };

  const { Option } = Select;




  const { mutateAsync: createCall, isLoading, data, isSuccess, isError, error } = useMutation( ( data ) => postNewCall( data )
    , {
      onSuccess: ( data, variables, context ) => {
        if ( data.status === 201 ) {
          setCall( callState );
          message.success( data.data.message );
          navigate( route.url, {
            ...route.options,
            callId: data.data.id
          } );
        } else {
          throw data;
        }
      },
      onError: ( error, variables, context ) => {
        const err = error.response.data.message;
        if ( _.isArray( err ) ) {
          err.map( err =>
            message.error( err.message )
          );
        }
        else {
          message.error( err );
        }
      },
      retry: true
    }

  );


  const handleSubmitCall = () => {
    callSchema.validate( call, {
      abortEarly: true,
      stripUnknown: true
    } ).then( valid => {
      if ( valid ) {
        createCall( call );
      }

    }

    ).catch( err => {
      console.log( err.erros );
      message.error( err.errors[ 0 ] );
    } );
  };


  const handleStartConsultation = () => {
    // call saving in progress
    if ( isLoading && !isSuccess ) {
      message.info( 'saving call...' );
    }

    // call not saved
    if ( !isLoading && !isSuccess ) {
      setRoute( {
        url: appLinks.consultations.new,
        options: {
          state: {
            patient: location.state.patient
          },
          replace: true
        }
      } );
      handleSubmitCall();
    }


    // call saved already
    if ( !isLoading && isSuccess ) {
      navigate( appLinks.consultations.new, {
        state: {
          patient: location.state.patient
        },
        replace: true
      } );
    }
  };

  useEffect( () => {
    if ( location.state?.patient?.id ) {
      setCall( {
        ...call,
        patientId: location.state?.patient?.id,
        callerNumber: location.state?.patient.contact
      } );
      setPatient( location.state?.patient );
    }
  }, [] );

  return (
    // <div className="quick-page">
    <div className="row">
      <div className="mx-auto col-md-10 col-12 content">
        <PageHeader
          title="Inbound Call"
          description="Call logger"
          hasBackButton
        >
          <button
            className="button app-btn bg-danger"
            onClick={ () => navigate( appLinks.home.index ) }
          >
            <span className="bi bi-x h5 text-white m-0"></span>
          </button>
        </PageHeader>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button className={ `button is-medium app-btn btn-prim mt-0 ${ isLoading && ' is-loading' }` }
            onClick={ handleSubmitCall }
          >
            <span className="bi bi-save h5 text-white me-2 mt-2"></span>
            Save
          </button>
          <button className={ `button is-medium app-btn ms-2 ${ ( isLoading && !isSuccess ) && ' is-loading' }` }
            onClick={ handleStartConsultation }
          >
            <span className="bi bi-plus-circle h5 me-2 mt-2"></span>
            Add Consultation
          </button>
        </div>
        <Divider />
        {/* <p className="mb-1">Patient Details</p> */ }
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h3 className="my-0">{ `${ patient.firstName } ${ patient.lastName }` }</h3>
            <p className="mt-0">{ `${ calcAge( patient.dob ).age } yrs old - ${ patient.gender }` }</p>
          </div>
          <button className="button" onClick={ ( e ) => setEditPatient( true ) }>Open Patient Details</button>
        </div>
        <Divider />
        <div className="row pb-5">
          <div className="col-md-5 col-12">
            <div className="field">
              <label className="mb-0" htmlFor="number">
                Caller Number
                <RequiredIndicator />
              </label>
              <input
                className="input"
                value={ call.callerNumber }
                onChange={ ( e ) => handleUpdateField( 'callerNumber', e.target.value ) }
                type="tel"
                maxLength={ 15 }
                autoFocus
                id="number"
                placeholder="caller number"
              />
            </div>
            <div className="field">
              <label className="mb-0" htmlFor="location">
                Caller Location
                <RequiredIndicator />
              </label>
              <input
                className="input"
                type="text"
                id="location"
                value={ call.callerLocation }
                onChange={ ( e ) => handleUpdateField( 'callerLocation', e.target.value ) }
                placeholder="caller location"
              />
            </div>
            <div className="field">
              <label className="mb-0" htmlFor="callType">
                Call Type
                <RequiredIndicator />
              </label>
              <Select
                required
                // onChange={(v) =>
                //   dropDownSet("gender", v, dropValue, setDropValues)
                // }
                size="large"
                id="callType"
                className="d-block"
                value={ call.callType }
                onChange={ ( v ) => handleUpdateField( 'callType', v ) }
                placeholder="call type"
              >
                <Option value="Prank Call">Prank Call</Option>
                <Option value="Enquiry">Enquiry</Option>
                <Option value="Consultation">Consultation</Option>
                <Option value="Incomplete">Incomplete</Option>
              </Select>
            </div>
            <div className="field">
              <Switch
                checked={ call.isProxyCall }
                onChange={ ( event ) => handleUpdateField( 'isProxyCall', event.target.checked ) }
                size="lg"
                onLabel="YES"
                offLabel="NO"
                label={
                  <span>
                    Is this a proxy call?
                    <RequiredIndicator />
                  </span>
                }
              />
            </div>
          </div>
          <div className="mt-md-0 mt-3 col-md-7 col-12">
            <label className="mb-0" htmlFor="summary">
              Call Summary
              {/* <RequiredIndicator /> */ }
            </label>
            <textarea
              className="textarea"
              rows={ 4 }
              style={ { minHeight: '40vh' } }
              id="summary"
              value={ call.summary }
              onChange={ ( e ) => handleUpdateField( 'summary', e.target.value ) }
              placeholder="type call summary here"
            ></textarea>
            {/* <RichTextEditor
              placeholder="type call summary here"
              controls={ [
                [ 'bold', 'italic', 'underline', 'link' ],
                [ 'unorderedList', 'h1', 'h2', 'h3' ],
              ] }
              style={ { minHeight: '40vh' } }
              id="summary"
              value={ call.summary }
              onChange={ ( e ) => handleUpdateField( 'summary', e ) }
            /> */}
          </div>
        </div>
      </div>
      <Modal
        title="Edit Patient"
        opened={ editPatient }
        onClose={ () => setEditPatient( false ) }
        size={ 700 }
      >
        <EditPatientForm patientId={ patient.id } showCharm={ false } isEditable={ false } />
      </Modal>
    </div>
  );
};

export { InBoundCall };